var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from "react";
import classNames from "classnames";
import { Button } from "../Button";
import { Icon } from "../Icon";
import { DropDown } from "../DropDown";
const defaultProps = {
    "data-testid": "tecma-header-item",
};
const HeaderItem = (_a) => {
    var { id, style, className, children, iconName, rightIconName, label, onClick } = _a, rest = __rest(_a, ["id", "style", "className", "children", "iconName", "rightIconName", "label", "onClick"]);
    const classList = classNames("tecma-header-item", className);
    const [isDropDownOpen, setIsDropDownOpen] = useState(false);
    const triggerClassList = classNames("tecma-header-item-trigger", { open: isDropDownOpen });
    const handleOnClick = (e) => {
        if (onClick) {
            onClick(e);
        }
        setIsDropDownOpen(!isDropDownOpen);
    };
    return children ? (_jsx(DropDown, Object.assign({ id: id, style: style, className: classList, isOpen: isDropDownOpen, rotateIconOnToggle: true, iconOnClose: "chevron-down", position: {
            vertical: "bottom",
            horizontal: "right",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "right",
        }, triggerProps: {
            children: (_jsxs(_Fragment, { children: [label && _jsx("span", { children: label }), iconName && _jsx(Icon, { iconName: iconName })] })),
            onClick: handleOnClick,
            className: triggerClassList,
            color: "transparent",
            iconSize: "medium",
        }, onToggle: () => setIsDropDownOpen(!isDropDownOpen) }, rest, { children: children }))) : (_jsxs(Button, { className: classList, iconName: iconName, color: "transparent", onClick: onClick || (() => { }), children: [label && _jsx("span", { children: label }), rightIconName && _jsx(Icon, { iconName: rightIconName })] }));
};
HeaderItem.defaultProps = defaultProps;
export default memo(HeaderItem);
